<template>
  <v-card flat>
    <v-container class="px-0 py-0" fluid>
      <v-row dense>
        <v-col class="mt-2">
          <SearchInspConditionForm
            :key="timeKey"
            :qrCode.sync="qrCode"
            :manufacturerCd.sync="manufacturerCd"
            :lotNo.sync="lotNo"
            :partCd.sync="partCd"
            :inspCompanyCd.sync="inspCompanyCd"
            @search="search"
            @reset="resetSearchResult"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col class="py-0">
          <InputAppInspForm :inspIndexNo="inspIndexNo" :cav.sync="cav" :numOfInsp.sync="numOfInsp" @reset="resetForm" />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import moment from 'moment'
import SearchInspConditionForm from '@/components/organisms/terminal/form/SearchInspConditionForm'
import InputAppInspForm from '@/components/organisms/terminal/form/InputAppInspForm'

export default {
  name: 'InputInspAppPage',

  components: {
    SearchInspConditionForm,
    InputAppInspForm,
  },

  data() {
    return {
      timeKey: '',
      qrCode: '',
      manufacturerCd: '',
      lotNo: '',
      partCd: '',
      inspCompanyCd: this.$store.getters.companyCd,
      inspIndexNo: '',
      cav: '',
      numOfInsp: null,
    }
  },

  methods: {
    async search(inspIndexNo) {
      this.resetSearchResult()
      await this.$nextTick()
      this.inspIndexNo = inspIndexNo
    },
    resetForm() {
      this.qrCode = ''
      this.manufacturerCd = ''
      this.lotNo = ''
      this.partCd = ''
      this.inspCompanyCd = this.$store.getters.companyCd
      this.resetSearchResult()
      this.timeKey = moment().format()
    },
    resetSearchResult() {
      this.inspIndexNo = ''
      this.cav = ''
      this.numOfInsp = null
    },
  },
}
</script>
